<template>
  <b-row align-h="between" align-v="end" class="the-detail__head">
    <b-col cols="10">
      <b-row align-h="start" align-v="center">
        <b-col cols="auto">
          <h1 class="site-detail__head__name">
            {{siteName}}
          </h1>
        </b-col>
        <b-col class="site-detail__head__actions" cols="auto">
          <a :href="siteDetail.data.url" class="site-detail__head__actions__linkfrontend" target="_blank">
            <span>
              {{$t('site.frontend')}}
            </span>
          </a>
          <a :href="backendUrl" class="site-detail__head__actions__linkbackend" target="_blank">
            <span>
              {{$t('site.backend')}}
            </span>
          </a>
          <span class="site-detail__head__actions__refresh">
            <span v-if="siteDetail.data.process_state === 0">Latest Refresh: {{ refreshedAt }} <img v-b-tooltip.top="$t('site.refreshdata')" class="btn" src="images/icon/sitedetail/icon_refresh.svg" v-on:click="localRefreshSiteData" /></span>
            <span v-else><font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon></span>
          </span>
        </b-col>
      </b-row>
    </b-col>
    <b-col col cols="auto">
      <span class="the-detail__head__windowcloser" v-on:click="close"><img alt="Close Detailview" src="images/icon/sitedetail/closer.svg"/></span>
    </b-col>
  </b-row>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import mixins from '../../mixins'

export default {
  name: 'SiteDetailHead',

  mixins: [mixins],

  computed: {
    ...mapState('user', [
      'userTimezone'
    ]),

    ...mapState('site', [
      'siteDetail',
      'showDetailPage'
    ]),

    ...mapGetters('progress', [
      'siteCoreUpdateProgress'
    ]),

    siteName () {
      if (typeof this.siteDetail.data.name === 'undefined') {
        return ''
      }

      return this.siteDetail.data.name.length > 30
        ? this.siteDetail.data.name.substring(0, 30) + ' ...'
        : this.siteDetail.data.name
    },

    backendUrl () {
      if (typeof this.siteDetail.data.configuration === 'undefined' || !this.siteDetail.data.configuration.backend_link) {
        return this.siteDetail.data.url_backend
      }

      return this.siteDetail.data.url + this.siteDetail.data.configuration.backend_link
    },

    refreshedAt () {
      return this.transformTime(this.siteDetail.data.updated_at, this.userTimezone)
    }

  },
  methods: {
    ...mapMutations('site', [
      'closeSiteDetailPage',
      'showSiteDetailPageBackups',
      'showSiteDetailPageExtensions',
      'showSiteDetailPageConfiguration',
      'setSiteDetailId'
    ]),

    ...mapActions('site', [
      'refreshSiteData'
    ]),

    ...mapActions('core', [
      'updateCoreForSite'
    ]),

    ...mapMutations('progress', [
      'setCoreUpdateProgress'
    ]),

    ...mapMutations('common', [
      'showSidebar'
    ]),

    close () {
      this.showSidebar()
      this.closeSiteDetailPage()
    },

    localRefreshSiteData () {
      this.refreshSiteData(this.siteDetail.id)
    },

    localRemoveSite () {
      this.closeSiteDetailPage()
      this.setSiteDetailId(0)
      this.$router.push({
        name: 'siteDestroy',
        params: {
          id: this.siteDetail.id
        }
      })
    }
  }
}
</script>
